import { FC } from "react";
import SmartSearchMonthYearAndActionsLayout from "../../../components/Layouts/smart-search-month-year-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import { GetMonthEndParams, getMonthEnd } from "../../../services/reports";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";
import {SearchStatusEnum} from "../../../enums/searchStatusEnum";
import dayjs from "dayjs";

const ReportMonthEnd: FC = () => {
  return (
    <SmartSearchMonthYearAndActionsLayout
      searchBy={[
        SearchOptionEnum.DISTRIBUTOR,
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      status={SearchStatusEnum.ACTIVE + "," + SearchStatusEnum.CLOSED}
      minYear={2014}
      actions={[ActionButtonEnum.REFRESH, ActionButtonEnum.SAVE_PDF]}
      onRefresh={(output, month, year, params) => {
          console.log(`Report Date month ${month} ${year}`)
          console.log(`Report Date month ${JSON.stringify(month)} ${JSON.stringify(year)}`)
        const getMonthEndParams: GetMonthEndParams = {
          output,
          fullMonth: dayjs()
            .set("date", 1)
            .set("year", Number(year))
            .set("month", Number(month))
            .format("YYYY-MM-DD"),
        };
console.log(`Report Date ${JSON.stringify(getMonthEndParams)}`)
        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getMonthEndParams[id] = params.id;
        }

        return getMonthEnd(getMonthEndParams);
      }}
    />
  );
};

export default ReportMonthEnd;
